module.exports = __webpack_public_path__ + "static/solid-cover-5ef3364c858f686ac6b13622b03fa4f5.png";